import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  GAME_NAV_SECTIONS,
  GAME_SECTION_COPY,
  interpolateGameCopy,
} from '../../constants/game-section.constants';
import type { GameNavSection, GameSection } from '../../models/game-section.model';

@Component({
  selector: 'app-game-section-nav',
  imports: [RouterLink],
  templateUrl: './game-section-nav.component.html',
  styleUrl: './game-section-nav.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameSectionNavComponent {
  game = input.required<GameSection>();
  activeSection = input.required<string>();

  // La página filtra las entradas por los bloques que el backend sirvió: una
  // entrada de nav hacia un ancla que no se pinta lleva a ninguna parte.
  sections = input<GameNavSection[]>(GAME_NAV_SECTIONS);

  sectionClick = output<string>();

  protected readonly ctaLabel = computed(() =>
    interpolateGameCopy(GAME_SECTION_COPY.navCta, { shortName: this.game().shortName }),
  );

  protected onSectionClick(sectionId: string): void {
    this.sectionClick.emit(sectionId);
  }
}
